(ns frontend.view.ai-summary-library.sub
  (:require
   [frontend.view.ai-summary-library.model :as model]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::state
 (fn [db]
   (get-in db model/root-path)))
